export function optionArrayZodSchema(
  options: Array<{ value: string }>,
  label: string,
  required: boolean | undefined
): string {
  const values = options.map((opt) => `'${opt.value}'`).join(', ')
  const valuesArray = `[${values}] as const`
  const baseArraySchema = required
    ? `z.array(z.string()).min(1, '${label} is required')`
    : 'z.array(z.string())'
  const arraySchema = `${baseArraySchema}.refine((values) => values.every((value) => (${valuesArray} as readonly string[]).includes(value)), { message: 'Invalid ${label}' })`
  return required ? arraySchema : `${arraySchema}.optional()`
}
